<div class="row" style="min-height: 100px">

  <div class="row mt-2">
    <div class="col-sm-12">
      <label for="exampleFormControlTextarea1">Contract <span aria-hidden="true" class="symbol required"
          style="color:red;">*</span></label>

    </div>
  </div>

  <pdf-viewer *ngIf="contractPdf" [src]="contractPdf" [rotation]="0" [original-size]="true" [show-all]="true"
    [fit-to-page]="true" [zoom]="1.1" [zoom-scale]="'page-width'" [stick-to-page]="true" [render-text]="true"
    [external-link-target]="'blank'" [autoresize]="true" [show-borders]="false" class="viewer">
  </pdf-viewer>


  <div class="row mt-3 ">
    <div class="col-md-4">
      <button type="submit" class="btn btn-lg btn-primary" [disabled]="this.loading" (click)="saveContract()">
        <span id="loading" role="status" aria-hidden="true"></span>
        Submit</button>
    </div>
  </div>
</div>
